import apiClient from './apiClient';

const Url = `/users`;

export const getProfile = async (props) => {
  try {
    let url = `${Url}/profile`;

    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const changePassword = async (props, data) => {
  try {
    let url = `${Url}/change-password`;

    let body = {
      oldPassword: data?.oldPassword,
      newPassword: data?.newPassword,
    };

    let response = await apiClient.post(url, body);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
